module.exports = __webpack_public_path__ + "img/2.780ccb41.jpeg";